// Mock data for Patagonia Lobby clone
import { Ship, Globe, Building2, Briefcase, Cpu, UtensilsCrossed, HeartPulse, Factory, ShoppingBag, FileText, ClipboardCheck, Target } from 'lucide-react';

export const stats = [
  { value: '+150', label: 'Proyectos gestionados' },
  { value: '28', label: 'Países de operación' },
  { value: '98%', label: 'Satisfacción del cliente' },
];

export const services = [
  {
    id: 'importacion',
    icon: Ship,
    title: 'Importación Estratégica',
    description:
      'Gestión integral de operaciones de importación con análisis arancelario, logístico y regulatorio para optimizar costos y tiempos.',
  },
  {
    id: 'exportacion',
    icon: Globe,
    title: 'Exportación y Expansión Internacional',
    description:
      'Diseño de estrategias de exportación con identificación de mercados, adecuación de producto y gestión documental completa.',
  },
  {
    id: 'internacionalizacion',
    icon: Building2,
    title: 'Internacionalización Empresarial',
    description:
      'Acompañamiento integral en procesos de internacionalización: estructura legal, operativa y comercial en mercados objetivos.',
  },
  {
    id: 'modelo',
    icon: Briefcase,
    title: 'Desarrollo de Modelos de Negocio Globales',
    description:
      'Diseño y validación de modelos de negocio para operaciones internacionales: pricing, estructura de costos y estrategia comercial.',
  },
];

export const processSteps = [
  {
    step: 'PASO 01',
    icon: FileText,
    title: 'Envío estructurado de solicitud',
    description:
      'Complete nuestro formulario especializado con los datos de su operación. Cada campo está diseñado para captar la información técnica necesaria.',
  },
  {
    step: 'PASO 02',
    icon: ClipboardCheck,
    title: 'Análisis técnico y regulatorio',
    description:
      'Nuestro equipo evalúa factibilidad, requisitos normativos, costos arancelarios y logísticos, y oportunidades de optimización.',
  },
  {
    step: 'PASO 03',
    icon: Target,
    title: 'Propuesta estratégica personalizada',
    description:
      'Reciba una propuesta detallada con cronograma, costos estimados, riesgos identificados y estrategia recomendada.',
  },
];

export const sectors = [
  { icon: Cpu, title: 'Tecnología', description: 'Hardware, software y soluciones digitales' },
  { icon: UtensilsCrossed, title: 'Alimentos y Bebidas', description: 'Productos frescos, procesados y gourmet' },
  { icon: HeartPulse, title: 'Salud', description: 'Equipos médicos, farmacéutica e insumos' },
  { icon: Factory, title: 'Industria', description: 'Maquinaria, materias primas y componentes' },
  { icon: ShoppingBag, title: 'Retail', description: 'Bienes de consumo y distribución' },
];

export const serviceTypes = [
  { id: 'importacion', icon: Ship, label: 'Importación' },
  { id: 'exportacion', icon: Globe, label: 'Exportación' },
  { id: 'internacionalizacion', icon: Building2, label: 'Internacionalización' },
  { id: 'modelo', icon: Briefcase, label: 'Modelo de Negocio' },
];

export const incoterms = ['EXW', 'FCA', 'FAS', 'FOB', 'CFR', 'CIF', 'CPT', 'CIP', 'DAP', 'DPU', 'DDP'];

export const documentationOptions = [
  'Completa',
  'Parcial',
  'En preparación',
  'Por definir',
];
